export const TEAMINBOX_NAME = 'Team Inbox'
export const TEAMINBOX_NAME_PLURAL = 'Team Inboxes'
export const TEAMINBOX_PATH_NAME = 'team-inboxes'